import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('NiotaClassic.Applications.form.titleUpdate') : _vm.$i18n_t('NiotaClassic.Applications.form.titleCreate')) + "\n    " + _vm._s(_vm.formItem.id ? ` - ${_vm.formItem.title}` : '') + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": !_vm.formValid
          },
          on: {
            "click": _vm.createOrUpdateApplication
          }
        }, [_vm._v("\n      " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('Common.save') : _vm.$i18n_t('Common.saveAndCreate')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('div', [_c('div', {
    staticClass: "image-upload-wrapper",
    on: {
      "click": function ($event) {
        return _vm.$refs.attachmentInput.click();
      }
    }
  }, [_c('img', {
    staticClass: "image-upload-img",
    attrs: {
      "src": _vm.formItem.image ? `${_vm.niota1ImageUrl(_vm.formItem.image)}` : 'img/niota-classic/placeholder.png'
    }
  }), _c('input', {
    ref: "attachmentInput",
    staticStyle: {
      "visibility": "hidden",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*",
      "disabled": !_vm.isIotHubManager
    },
    on: {
      "change": _vm.imageInputChanged
    }
  })])])]), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Applications.form.title'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.title,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "title", $$v);
      },
      expression: "formItem.title"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Applications.form.account'),
      "color": _vm.color,
      "rules": [() => !!_vm.formItem.accountId || this.$i18n_t('Common.fieldRequired')],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager,
      "items": _vm.plainAccounts,
      "filter": _vm.filterAccounts,
      "auto-select-first": "",
      "item-text": "name",
      "item-value": "id",
      "hide-details": "auto",
      "return-object": ""
    },
    on: {
      "input": _vm.accountUpdated
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.name))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.formItem.account,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "account", $$v);
      },
      expression: "formItem.account"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "rows": "5",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": `${_vm.$i18n_t('NiotaClassic.Applications.form.description')} (${_vm.$i18n_t('NiotaClassic.Applications.form.MdownSupport')})`,
      "autocomplete": "off",
      "hide-details": "auto",
      "disabled": !_vm.isIotHubManager
    },
    model: {
      value: _vm.formItem.description,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "description", $$v);
      },
      expression: "formItem.description"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Applications.form.iotServiceUrl'),
      "color": _vm.color,
      "rules": _vm.formItem.url ? _vm.urlRule : [],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isIotHubManager || _vm.formSaving,
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    model: {
      value: _vm.formItem.url,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "url", $$v);
      },
      expression: "formItem.url"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-n1-tags', {
    attrs: {
      "tags": _vm.formItem.tags,
      "disabled": !_vm.isIotHubManager
    },
    on: {
      "process": _vm.tagsChanged
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.diagramPeriods,
      "label": _vm.$i18n_t('NiotaClassic.Applications.form.diagram'),
      "item-text": "text",
      "item-value": "value",
      "hide-details": "",
      "disabled": !_vm.isIotHubManager
    },
    model: {
      value: _vm.formItem.metrics_length,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "metrics_length", $$v);
      },
      expression: "formItem.metrics_length"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Applications.form.fixSendingInterval'),
      "hide-details": "",
      "disabled": !_vm.isIotHubManager
    },
    model: {
      value: _vm.formItem.fixedInterval,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "fixedInterval", $$v);
      },
      expression: "formItem.fixedInterval"
    }
  })], 1), _c(VCol, {
    staticClass: "pb-1",
    attrs: {
      "cols": "12",
      "md": "11"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Applications.form.detailsViewOptions')))])]), _c(VCol, {
    attrs: {
      "cols": "3",
      "sm": "6",
      "xs": "12",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Applications.form.nominal'),
      "hide-details": "",
      "disabled": !_vm.isIotHubManager
    },
    model: {
      value: _vm.formItem.properties.detailsViewCards.nominal,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties.detailsViewCards, "nominal", $$v);
      },
      expression: "formItem.properties.detailsViewCards.nominal"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "3",
      "sm": "6",
      "xs": "12",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Applications.form.status'),
      "hide-details": "",
      "disabled": !_vm.isIotHubManager
    },
    model: {
      value: _vm.formItem.properties.detailsViewCards.status,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties.detailsViewCards, "status", $$v);
      },
      expression: "formItem.properties.detailsViewCards.status"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "3",
      "sm": "6",
      "xs": "12",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Applications.form.statistics'),
      "hide-details": "",
      "disabled": !_vm.isIotHubManager
    },
    model: {
      value: _vm.formItem.properties.detailsViewCards.statistics,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties.detailsViewCards, "statistics", $$v);
      },
      expression: "formItem.properties.detailsViewCards.statistics"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "3",
      "sm": "6",
      "xs": "12",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Applications.form.Sfgraph'),
      "disabled": !_vm.isIotHubManager,
      "hide-details": ""
    },
    model: {
      value: _vm.formItem.properties.detailsViewCards.SFgraph,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties.detailsViewCards, "SFgraph", $$v);
      },
      expression: "formItem.properties.detailsViewCards.SFgraph"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('core-address-picker', {
    attrs: {
      "disabled": !_vm.isIotHubManager,
      "addressObject": _vm.addressObject,
      "coordinateLookup": _vm.coordinateLookup,
      "floatRule": false
    },
    on: {
      "address-selected": _vm.addressSelected,
      "address-blured": _vm.setAddressObject
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };